<template>
  <div class="error-wrapper">
    <img class="error-img" src="@/assets/img/error-image.png" alt="错误" />
    <h2>页面参数错误，请联系管理员</h2>
    <van-button type="primary" @click="$router.replace('/')">返回首页</van-button>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage'
}
</script>

<style scoped>
.error-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff0f0;
}
.error-img {
  width: 180px;
  height: auto;
  margin-bottom: 32px;
  border-radius: 12px;
}
h2 {
  color: #ee2223;
  margin-bottom: 24px;
}
</style> 